/**
 * Fechas sin hora, `AAAA-MM-DD`: la vigencia de una lista, el día de un precio programado.
 *
 * `new Date().toISOString().slice(0, 10)` es el día **en UTC**, y en Buenos Aires eso es mañana a
 * partir de las nueve de la noche: una lista que vence hoy desaparecía de la pantalla tres horas
 * antes. Acá el día es el del navegador.
 *
 * SUPUESTO: el navegador está en la zona horaria del comercio. El servidor decide con la del
 * comercio y es el que manda; esto sólo evita que la pantalla ofrezca lo que la venta va a rechazar.
 */
export function hoyLocal(): string {
  const ahora = new Date();
  const mes = String(ahora.getMonth() + 1).padStart(2, '0');
  const dia = String(ahora.getDate()).padStart(2, '0');
  return `${String(ahora.getFullYear())}-${mes}-${dia}`;
}

/**
 * Una fecha `AAAA-MM-DD` como la lee la gente, en el idioma activo.
 *
 * Se arma con la hora local a propósito: `new Date('2026-10-28')` es la medianoche UTC, y al
 * mostrarla en Buenos Aires sale el 27.
 */
export function fechaParaMirar(fecha: string, idioma: string): string {
  const [anio = 0, mes = 1, dia = 1] = fecha.slice(0, 10).split('-').map(Number);
  return new Date(anio, mes - 1, dia).toLocaleDateString(idioma);
}

/** Lo que hace falta saber de una lista para decidir si se vende con ella. */
export interface ConVigencia {
  readonly activa: boolean;
  readonly vigenteDesde: string | null;
  readonly vigenteHasta: string | null;
}

/** Si se puede vender con la lista hoy: activa y dentro de su vigencia (E36). */
export function vigenteHoy(lista: ConVigencia): boolean {
  const hoy = hoyLocal();
  return (
    lista.activa &&
    (lista.vigenteDesde === null || hoy >= lista.vigenteDesde) &&
    (lista.vigenteHasta === null || hoy <= lista.vigenteHasta)
  );
}
